module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAMAAAAMs7fIAAAAAXNSR0IB2cksfwAAAFFQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXKkVQgAAABt0Uk5TADlXejgPYTYVBjdgDl4DXwQWVQd5F1YFnA2AwDnG9AAAAHBJREFUeJyNjUkWgCAMQ5lEZpTB6f4HVUSoCxdm0fT916QIXcKEUsJQ18BHIaVQ2jRgXV2cfxB37Xjyt+ER8kyVSQSQOZRJJZCYvsk7lRdoq8J11/37aqsbPz1g21FDbI4xY7sfPa9CSkvpANT1D+kTOjQD8ea67+8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/v2/search-icon.png
// module id = 174
// module chunks = 33